<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<p-panel header="{{ 'CENTRALRIESGO.LBL_CENRIESAGREGAR' | translate }}" *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <label>{{'CENTRALRIESGO.LBL_INTEGRACIONES' | translate}}:</label>
            <label class="falso-combo-texto">{{ centralRiesgoIntegracion.integracion }}</label>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-3 md:col-3 lg:col-3 col-offset-3 md:col-offset-3 lg:col-offset-3">
          <div class="div-form">
            <label>{{'CENTRALRIESGO.LBL_DIAVIGENCIA' | translate}}</label>
          </div>
        </div>
        <div class="col-3 md:col-3 lg:col-3 ">
          <div class="div-form">
            <label class="falso-combo-texto">{{centralRiesgoIntegracion.diasVigencia}}</label>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-3 md:col-3 lg:col-3 col-offset-3 md:col-offset-3 lg:col-offset-3">
          <div class="div-form">
            <label><strong>{{'CENTRALRIESGO.LBL_RANGOVIGENCIA' | translate}}</strong></label>
          </div>
        </div>

      </div>
      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 col-offset-3 md:col-offset-3 lg:col-offset-3">
          <div class="div-form">
            <p-table [columns]="columnas" [loading]="carTabla" #dt
                     [value]="rangoDias" selectionMode="single" dataKey="idRangoDias"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td class="text-center">{{row.dia}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">{{ 'MSG_NOHAYREGISTROS' | translate}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <label>{{'CENTRALRIESGO.LBL_ESTADOBLOQUEADO' | translate}}:</label>
            <label class="falso-combo-texto">{{centralRiesgoIntegracion.estado}}</label>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <label>{{'CENTRALRIESGO.LBL_CORREOINFORMACION' | translate}}:</label>

            <label class="falso-combo-texto">{{centralRiesgoIntegracion.correo}}</label>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <p-checkbox [(ngModel)]="centralRiesgoIntegracion.indicadorEncendido" value="{{centralRiesgoIntegracion.indicadorEncendido}}"
                        [disabled]="true"
                        binary="true"></p-checkbox>
            <label class="pl-2">{{'CENTRALRIESGO.LBL_ENCENDIDOANALIZAMOS' | translate}}</label>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <p-checkbox [(ngModel)]="centralRiesgoIntegracion.indicadorEncendidoAliado"
                        [disabled]="true"
                        value="{{centralRiesgoIntegracion.indicadorEncendidoAliado}}" binary="true"></p-checkbox>
            <label class="pl-2">{{'CENTRALRIESGO.LBL_ENCENDIDOALIADOS' | translate}}</label>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <p-checkbox [(ngModel)]="centralRiesgoIntegracion.indicadorEncendidoPersonas"
                        [disabled]="true"
                        value="{{centralRiesgoIntegracion.indicadorEncendidoPersonas}}" binary="true"></p-checkbox>
            <label class="pl-2">{{'CENTRALRIESGO.LBL_ENCENDIDOPERSONAS' | translate}}</label>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
          <div class="div-form">
            <p-checkbox [(ngModel)]="indConsulta" value="{{indConsulta}}"
                        [disabled]="true"
                        binary="true"></p-checkbox>
            <label class="pl-2">{{'CENTRALRIESGO.LBL_CONSULTAXSOLICITUD' | translate}}</label>
          </div>
        </div>
      </div>

      <div class="grid form-footer-buttons">
        <div class=" col-4 md:col-4 lg:col-4 lg:col-offset-4 md:col-offset-4">
          <div>
            <button style="width: 100%" type="button" pButton label="{{'BTN_REGRESAR' | translate }}"
                    (click)="regresar()"></button>
          </div>
        </div>
      </div>

    </div>
  </div>
</p-panel>

